module.exports = __webpack_public_path__ + "static/media/wasmachine.b038c8df.png";